import { useRef as m } from "react";
import "../../../components/Toast/Toast.js";
import { ToastProvider as n } from "../../../components/Toast/ToastProvider/ToastProvider.js";
import { ToastViewport as c } from "../../../components/Toast/ToastViewport/ToastViewport.js";
import { ToastsStack as d } from "../ToastsStack/ToastsStack.js";
import { jsxs as f, jsx as r } from "theme-ui/jsx-runtime";
const S = (t) => {
  const {
    expandedStack: e,
    children: s,
    viewportSx: i,
    clearToastsOnUnmount: a,
    ...p
  } = t, o = m(null);
  return /* @__PURE__ */ f(n, {
    ...p,
    children: [s, /* @__PURE__ */ r(d, {
      toastViewportRef: o,
      expanded: e,
      clearToastsOnUnmount: a
    }), /* @__PURE__ */ r(c, {
      ref: o,
      sx: i
    })]
  });
};
export {
  S as ToastsStackProvider
};
